import { WSText } from "@wingspanhq/fe-component-library";
import styles from "./RequirementInstructionsView.module.scss";
import Markdown from "react-markdown";
import React from "react";

export const RequirementInstructionsView: React.FC<{
  instructions: string;
}> = ({ instructions }) => {
  return (
    <WSText color="gray700" weight="book" className={styles.reset}>
      <Markdown>{instructions}</Markdown>
    </WSText>
  );
};
